import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { fetchSales, selectSales } from '../features/store/sales/sale.slice';
import { getDefaultSaleSearchCriteria } from '../service/model/store.model';

const useSales = () => {
    const dispatch = useAppDispatch();
    const sales = useAppSelector(selectSales);

    const getSales = async () => {
        await dispatch(fetchSales(getDefaultSaleSearchCriteria()));
    };

    useEffect(() => {
        if (sales.length === 0) {
            getSales();
        }
    }, []);

    return [sales];
};

export default useSales;
